import { render } from "./SetMedia.vue?vue&type=template&id=9ae6f7cc&scoped=true"
import script from "./SetMedia.vue?vue&type=script&lang=js"
export * from "./SetMedia.vue?vue&type=script&lang=js"

import "./SetMedia.vue?vue&type=style&index=0&id=9ae6f7cc&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ae6f7cc"]])

export default __exports__